module.exports = __webpack_public_path__ + "assets/img/ercode-1.7e35fd0f.jpg";